import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import { vec2, vec3, vec4, mat4 } from "_src/libs/gl-matrix";

import vertText from "_src/shaders/circle/circle.glslv";
import fragText from "_src/shaders/circle/circle.glslf";

const _vec3Tmp = vec3.create();

export default class CircleShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.standardDerivativesEnabled = true;
    this.transparent = true;
    this.backFaceCulling = false;

    this.attachUniforms();

  }

  //reimplementation
  initDirectives(params) {
    this._directives["BLUR_TEXTURE"] = params.useBlur !== undefined ? params.useBlur : false;
  }

  compile() {
    super.compile(vertText, fragText);
  }

  updateObjectUniformValues(object) {
    mat4.copy(this.uniforms["u_model_matrix"].value, object.modelMatrix);
    vec4.copy(this.uniforms["u_diffuse"].value, object.properties.diffuseColor);
  }

  updateSceneUniformValues(scene) {
    const camera = scene.camera;
    mat4.copy(this.uniforms["u_view_proj_matrix"].value, camera.viewProjMat);
    vec2.copy(this.uniforms["u_texel_size"].value, camera.texelSize);
  }

  attachUniforms() {

    const diffuseColor = vec4.fromValues(0.8, 0.8, 0.8, 1.0);
    const modelMatrix  = mat4.create();
    const viewProjectionMatrix = mat4.create();
    const texelSize = vec2.create();
    const backfaceColor = vec3.fromValues(0.8, 0.8, 0.4);

    this.uniforms["u_model_matrix"]     = new Uniform(uniformType.MAT4, modelMatrix, uniformSource.OBJECT);
    this.uniforms["u_diffuse"]          = new Uniform(uniformType.FLOAT4V, diffuseColor, uniformSource.OBJECT);
    this.uniforms["u_view_proj_matrix"] = new Uniform(uniformType.MAT4, viewProjectionMatrix, uniformSource.SCENE);
    this.uniforms["u_texel_size"]       = new Uniform(uniformType.FLOAT2V, texelSize, uniformSource.SCENE);
    this.uniforms["tDiffuse"]           = new Uniform(uniformType.INT1, 0);
    this.uniforms["u_backface_color"]   = new Uniform(uniformType.FLOAT3, backfaceColor);
  }

  setBackFaceColor(r, g, b) {
    const color = vec3.set(_vec3Tmp, r, g, b);
    this.setUniform("u_backface_color", color);
  }

}
